import { gql } from '@apollo/client';

/** SYM-6351. Save the campaign's job title and/or location: { title?: {mode, text}, location?: {mode, text} }. */
export const SAVE_AD_VALUES = gql`
  mutation saveAdValues($vacancyId: ID!) {
    saveAdValues(input: $input, id: $vacancyId)
      @rest(
        type: "AdValuesSaved"
        path: "/v4/vacancies/{args.id}/ad-values"
        method: "POST"
      ) {
      ad_values
    }
  }
`;

/** "Update N live ads", or one ad from its marker: { ad_variant_ids?: number[] }. */
export const UPDATE_LIVE_ADS = gql`
  mutation updateLiveAds($vacancyId: ID!) {
    updateLiveAds(input: $input, id: $vacancyId)
      @rest(
        type: "LiveAdsUpdated"
        path: "/v4/vacancies/{args.id}/live-ads/update"
        method: "POST"
      ) {
      updated
      # SYM-6757: on a running campaign the update is kept for "Publish changes".
      kept
    }
  }
`;

/** "Leave them" (D25). */
export const LEAVE_LIVE_ADS = gql`
  mutation leaveLiveAds($vacancyId: ID!) {
    leaveLiveAds(input: $input, id: $vacancyId)
      @rest(
        type: "LiveAdsLeft"
        path: "/v4/vacancies/{args.id}/live-ads/leave"
        method: "POST"
      )
  }
`;

/** A notice has been seen: notice is "restart-updated" or "ad-texts-language". */
export const ACK_NOTICE = gql`
  mutation ackCampaignNotice($vacancyId: ID!, $notice: String!) {
    ackCampaignNotice(input: $input, id: $vacancyId, notice: $notice)
      @rest(
        type: "CampaignNoticeAcked"
        path: "/v4/vacancies/{args.id}/notices/{args.notice}/ack"
        method: "POST"
      )
  }
`;

/** "Translate these texts": the translations, per ad id, for the editor to show unsaved. */
export const TRANSLATE_AD_TEXTS = gql`
  mutation translateAdTexts($vacancyId: ID!) {
    translateAdTexts(input: $input, id: $vacancyId)
      @rest(
        type: "AdTextsTranslated"
        path: "/v4/vacancies/{args.id}/ad-texts/translate"
        method: "POST"
      ) {
      language_id
      translated_to
      ad_variants
    }
  }
`;
